/**
 * 记忆偏好管理弹窗（Container）
 * @see https://tapd.tencent.com/tapd_fe/20427644/story/detail/1020427644135375711
 */
import React from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';
import MemorySwitchSection from './components/MemorySwitchSection';
import MemorySummarySection from './components/MemorySummarySection';
import { useMemoryPreferencesModal } from './hooks';
import type { IMemoryPreferencesProps } from './types';
import './index.scss';

const MemoryPreferences: React.FC<IMemoryPreferencesProps> = ({
  visible = true,
  onClose,
}) => {
  const { formatMessage } = useIntl();
  const {
    isMemoryEnabled,
    hasMemory,
    formattedMemory,
    loading,
    handleToggleMemory,
  } = useMemoryPreferencesModal();

  if (!visible) {
    return null;
  }

  const enabledDesc = formatMessage({
    id: 'dba_memory_enabled_desc',
    defaultMessage:
      'Brainy 将在后续分析中自动使用已保存的分析偏好、报告格式和近期关注事项，为你提供更连续、个性化的分析体验',
  });

  const disabledDesc = formatMessage({
    id: 'dba_memory_disabled_desc',
    defaultMessage:
      '已有记忆会保留，仅供查看，不会用于生成回答，也不会新增或更新。重新开启后可继续使用。',
  });

  return (
    <Modal
      className="dba-memory-preferences-modal"
      visible={visible}
      onClose={onClose}
      caption={formatMessage({
        id: 'dba_memory_title',
        defaultMessage: '记忆管理',
      })}
    >
      <Modal.Body>
        <div
          className={`dba-memory-preferences-content${
            hasMemory ? ' dba-memory-preferences-content--filled' : ''
          }`}
        >
          <MemorySwitchSection
            label={formatMessage({
              id: 'dba_enable_memory',
              defaultMessage: '启用记忆',
            })}
            description={isMemoryEnabled ? enabledDesc : disabledDesc}
            enabled={isMemoryEnabled}
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onToggle={handleToggleMemory}
          />
          <MemorySummarySection
            title={formatMessage({
              id: 'dba_memory_summary',
              defaultMessage: '记忆摘要',
            })}
            emptyText={formatMessage({
              id: 'dba_no_memory',
              defaultMessage: '暂无记忆',
            })}
            hasMemory={hasMemory}
            formattedMemory={formattedMemory}
            loading={loading}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MemoryPreferences;
